import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;

const Blockly = GlobalImport.getBlockly();

const DECISION = 'DECISION';
const TRUE_PART = 'TRUE_PART';

export class IfBlock extends AbstractBlock {
  constructor(name: string) {
    super(name, 'if');
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setLogicColor(block);
    ShapeSettings.setElementWithSubBlockShape(block);

    // 属性値の入力フィールド
    block.appendValueInput(DECISION).setCheck('Boolean').appendField(t.to('もし', 'if_label'));
    block.appendDummyInput().appendField(t.to('なら', 'then_label'));
    block.appendStatementInput(TRUE_PART);
  }

  codeGenerateCore(block: BlockType): string {
    const decision = CodeSetting.getInputValue(block, DECISION);
    const true_part = Blockly.JavaScript.statementToCode(
      block,
      TRUE_PART,
      Blockly.JavaScript.ORDER_NONE
    );

    // let str = '{% if ( ' + decision +  ' )  %}';
    // if (true_part !== ""){
    // 	str += '\n' + true_part;
    // }
    // str += '{% endif %}\n';

    const str = ` if ( ${decision}  ){
			${true_part}
		}`;
    return str;
  }
}
